export default __webpack_public_path__ + "static/media/clarity-tree.46fac345.svg";